// src/components/Header.js
import React from "react";
import "../css/main.css";
import "../css/responsive.css";
import envelope from "../images/Envelope.png";
import phone from "../images/PhoneCall.png";
import messenger from "../images/facebook-white.png";
import Logo from "../components/Logo";
import instagram from "../images/InstagramLogo.png";
import whatsapp from "../images/whatsapp-white.png";

import { useNavigate } from "react-router-dom";
import useUserData from "../hooks/useUserData";

const Header = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");
  const user = useUserData();

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login");
  };

  // const toggleMenu = () => {
  //   const dropdown = document.querySelector(".dropdown");
  //   if (dropdown) {
  //     dropdown.classList.toggle("active");
  //   }
  // };

  return (
    <header>
      <div className="top-header">
        <div className="mail">
          <div className="icon">
            <img alt="header-icon" src={envelope} />
          </div>
          <a href="mailto:aware@gmail.com">aware@gmail.com</a>
        </div>
        <div className="socials">
          <div className="social phone-number">
            <a href="tel:+40723071022" className="icon">
              <img alt="header-icon" src={phone} />
            </a>
            <label>+40 723 071 022</label>
          </div>
          <div className="social messenger">
            <a
              href="https://www.facebook.com/theorlov.centrudepsihoterapie?mibextid=wwXIfr&rdid=eNrpX1Vzl3sruERT&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1PjfTfw4zM%2F%3Fmibextid%3DwwXIfr#"
              className="icon"
            >
              <img alt="header-icon" src={messenger} />
            </a>
          </div>
          <div className="social instagram">
            <a
              href="https://www.instagram.com/_theorlov_/?igsh=dnd0NHl6dmw3b3l2&utm_source=qr#"
              className="icon"
            >
              <img alt="header-icon" src={instagram} />
            </a>
          </div>
          <div className="social whatsapp">
            <a href="https://wa.me/40723071022" className="icon">
              <img alt="header-icon" src={whatsapp} />
            </a>
          </div>
        </div>
      </div>

      <div className="main-header">
        <a href="/" className="logo">
          <Logo />
        </a>
        <div className="links">
          {/* <div className="burger-menu">
            <i className="fa-solid fa-bars" onClick={toggleMenu}></i>
            <div className="dropdown">
              <a className="link active" href="/login">
                Acasa
              </a>
              <a className="link" href="/despre-noi">
                Despre noi
              </a>
              <a className="link" href="/servicii">
                Servicii
              </a>
              <a className="link" href="#team-aware">
                Echipa noastra
              </a>
              <a className="link" href="/login">
                Magazin
              </a>
              <a className="link" href="/events">
                Evenimente
              </a>
            </div>
          </div> */}
          <a className="link" href="/">
            Acasa
          </a>
          <a className="link" href="/despre-noi">
            Despre noi
          </a>
          <a className="link" href="/servicii">
            Servicii
          </a>
          <a className="link" href="/under-construction">
            Magazin
          </a>
          <a className="link" href="/evenimente">
            Evenimente
          </a>
        </div>

        <div className="action">
          {token ? (
            <div className="burger-buttons">
              <div className="user">
                <div className="name">
                  {user ? `${user.first_name}` : "Autentificat"}
                </div>
                <i class="fa-solid fa-caret-down"></i>
              </div>
              <div className="buttons-dropdown">
                <a href="/" onClick={handleLogout}>
                  Deloghează-te
                </a>
                <a className="links-redirect" href="/">
                  Acasa
                </a>
                <a className="links-redirect" href="/despre-noi">
                  Despre noi
                </a>
                <a className="links-redirect" href="/servicii">
                  Servicii
                </a>
                <a className="links-redirect" href="/under-construction">
                  Echipa noastra
                </a>
                <a className="links-redirect" href="/under-construction">
                  Magazin
                </a>
                <a className="links-redirect" href="/evenimente">
                  Evenimente
                </a>
              </div>
            </div>
          ) : (
            <div className="burger-buttons">
              <div className="user">
                <i className="fa-solid fa-bars"></i>
              </div>
              <div className="buttons-dropdown">
                <a href="/login">Loghează-te</a>
                <a href="/register">Înregistrează-te</a>
                <a className="links-redirect" href="/">
                  Acasa
                </a>
                <a className="links-redirect" href="/despre-noi">
                  Despre noi
                </a>
                <a className="links-redirect" href="/servicii">
                  Servicii
                </a>
                <a className="links-redirect" href="/under-construction">
                  Echipa noastra
                </a>
                <a className="links-redirect" href="/under-construction">
                  Magazin
                </a>
                <a className="links-redirect" href="/evenimente">
                  Evenimente
                </a>
              </div>
            </div>
          )}
          <a href="/contact" className="button primary">
            CONTACT
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
